import React from "react";

export default function Footer() {
  return (
    <footer id="contact" className="bg-white py-12 border-t border-slate-100">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          
          <div className="flex items-center">
            <img
              src="/logo.png"
              alt="Americar"
              className="h-10 w-auto object-contain"
            />
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm font-medium text-slate-500">
            <a href="/#howitworks" className="hover:text-primary transition-colors">How it Works</a>
            <a href="/#features" className="hover:text-primary transition-colors">Features</a>
            <a href="/#vendors" className="hover:text-primary transition-colors">For Business</a>
            <a href="#" className="hover:text-primary transition-colors">Privacy</a>
            <a href="#" className="hover:text-primary transition-colors">Terms</a>
          </div>

          <div className="text-sm font-medium text-slate-400">
            &copy; {new Date().getFullYear()} Americar. All rights reserved.
          </div>

        </div>
      </div>
    </footer>
  );
}
